import React from 'react'

function Faq(props) {
  return (
    <section>
    <h2>FAQ</h2>
    <h3>推奨ブラウザ</h3>
    <ul>
      <li>Chrome</li>
      <li>Firefox（ウェブ開発ツールを開いた状態で変換を行うと、エラーが発生する問題が出ています。）</li>
      <li>Edge</li>
    </ul>
    <p>この3つで動作する事は確認しています。上手く変換できてなさそうな場合、ブラウザを変えてみてください。</p>
    <h3>対応画像形式</h3>
    <ul>
      <li>jpeg</li>
      <li>png</li>
    </ul>
    <p>この2つで動作確認をしています。他の画像形式でも動くものもあるかもしれませんが、未確認です。</p>
    <h3>画像を放り込んでも何も起こらない</h3>
    <p>エラーが発生した場合に、エラーが発生したと表示する部分がまだ未実装です。すいませんが、ブラウザの開発者ツールで何かエラーが発生しているかどうかを見てみてください。</p>
    <h3>画像と動画のサイズについて</h3>
    <p>変換後の動画の縦横のサイズについては、元となった画像と同じになります。</p>
    <p>縦横のサイズやファイルサイズについて、上限があるかどうかは確認できてないです。</p>
    <h3>作りが雑な事について</h3>
    <p>もう少し整えてから公開しようと思っていましたが、しばらく他の事で手一杯になりそうなので、一旦現状で公開する事にしました。時間が出来たら、エラー処理やスタイルなどを改善したいです。</p>
    <h3>その他のご質問やご連絡</h3>
    <p>Twitterで<a href="https://twitter.com/kanonji">@kanonji</a>までご連絡ください。</p>
    <hr />
    <h3>アクセス解析について</h3>
    <p>このwebサイトでは、アクセス解析にGoogleアナリティクスを使用しています。Googleアナリティクスはトラフィックデータの収集のためにCookieを使用します。詳しくは<a href="https://policies.google.com/technologies/partner-sites?hl=ja">Google のサービスを使用するサイトやアプリから収集した情報の Google による使用 – ポリシーと規約 – Google</a>をご確認ください。</p>
  </section>
  )
}

export default Faq